import cn from 'classnames'
import { instanceOf } from 'prop-types'

import localizedPostTime from '../../../../utilities/localizedPostTime.js'
import UserProfileImage from '../../theme-components/user-profile-image.js'
import Settings from '../../../../../models/settings.js'
import Post from '../../../../../models/Post.js'

function CarouselContributor({ post, settings }) {
  const { isMinimalistic, postHeaderCentered, locale } = settings
  if (isMinimalistic) {
    return null
  }

  return (
    <div
      className={cn('bzfy-o-header', {
        'bzfy-o-header--center': postHeaderCentered,
      })}
    >
      {settings.showProfileImage && (
        <div aria-hidden="true" className="bzfy-o-header__image-container">
          <UserProfileImage {...post} className="bzfy-o-header__image" source={post.sourceName} />
        </div>
      )}
      {settings.displayName && post.userName && (
        <div className="bzfy-o-header__user">
          <span className="bzfy-o-visually-hidden">
            {settings.locale.getTranslation('postPublishedBy')}
          </span>
          <span>{post.userName}</span>
        </div>
      )}
      {settings.postAge && (
        <div className="bzfy-o-header__time">{localizedPostTime(post, locale)}</div>
      )}
    </div>
  )
}

CarouselContributor.propTypes = {
  post: instanceOf(Post).isRequired,
  settings: instanceOf(Settings).isRequired,
}

export default CarouselContributor
